import styled from "styled-components";

const Flex = styled.div`
  display: flex;
  align-items: ${({ items }) => items || "flex-start"};
  justify-content: ${({ justify }) => justify || "flex-start"};
  flex-direction: ${({ direction }) => direction || "row"};
  gap: ${({ gap }) => gap || "0"};
  flex-wrap: ${({ wrap }) => wrap || "nowrap"};
  width: ${({ width }) => width || "auto"};
  height: ${({ height }) => height || "auto"};
  min-height: ${({ minh }) => minh || "0"};
  max-width: ${({ maxw }) => maxw || "auto"};
  padding: ${({ padding }) => padding || "0"};
  margin: ${({ margin }) => margin || "0"};
  position: ${({ position }) => position || "static"};
  z-index: ${({ zIndex }) => zIndex || "0"};
  border-top: ${({ bT }) => bT || "none"};
  border: ${({ border }) => border || "none"};
  border-radius: ${({ borderRadius }) => borderRadius || "0"};
  ${({ top }) => top && `top: ${top}`};
  ${({ left }) => left && `left: ${left}`};
  ${({ right }) => right && `right: ${right}`};
  ${({ bottom }) => bottom && `bottom: ${bottom}`};
  background: ${({ bg }) => bg || "none"};

  @media (max-width: 768px) {
    gap: ${({ gap, gapMobile }) => gapMobile || gap};
    flex-direction: ${({ directionMobile, direction }) => directionMobile || direction};
    flex-wrap: ${({ wrapMobile, wrap }) => wrapMobile || wrap};
    padding: ${({ paddingMobile, padding }) => paddingMobile || padding };
    text-align: ${({ textAlignMobile, textAlign }) => textAlignMobile || textAlign};
    margin: ${({ marginMobile, margin }) => marginMobile || margin};
    align-items: ${({ itemsMobile, items }) => itemsMobile || items };
    min-height: ${({ minHMobile, minh }) => minHMobile || minh};
    justify-content: ${({ justifyMobile, justify }) => justifyMobile || justify};
    ${({ order }) => `order: ${order}`};
  }
`;

export default Flex;
